// import React, { } from 'react';
import ChilliChi from "../assets/chilli-chicken.jpg";
import Dosa from "../assets/dosa.jpg";
import Paneer from "../assets/paneer.jpg";
import Idli from "../assets/idli.jpg";
import Gulab from "../assets/Gulab-Jamun.jpg";
import Lassi from "../assets/Sweet-Lassi.jpg";
import Dhokla from "../assets/dhokla.jpg";
import Mashroom from "../assets/matar-mushroom.jpg";
import Manchurian from "../assets/veg-manchurian.jpg";
// import { DirectionsWalkSharp } from "@material-ui/icons";

export const RecipeList = [
  {
    name: "Chilli Chicken",
    image: ChilliChi,
    about: 'Chilli chicken is a popular Indo-Chinese dish of chicken of Hakka Chinese heritage.',
    source_url: "https://www.indianhealthyrecipes.com/chilli-chicken-dry-recipe-indo-chinese-style/",
  },
  {
    name: "Masala Dosa",
    image: Dosa,
    about: 'Masala dosa is a variation of the popular South Indian dosa, which has its origins in Udupi cuisine of Karnataka.',
     source_url: "https://www.indianhealthyrecipes.com/masala-dosa-recipe/",
  },
  {
    name: "Paneer Butter",
    image: Paneer,
    about: "Paneer butter masala is a slightly sweet dish of paneer, originating from the Indian subcontinent.",
    source_url: "https://www.indianhealthyrecipes.com/paneer-butter-masala-restaurant-style/", 
  },
  {
    name: "Idli ",
    image: Idli,
    about: "Idli are a type of savoury rice cake, popular as breakfast foods in Southern India and in Sri Lanka.",
     source_url: "https://www.vegrecipesofindia.com/idli-recipe-how-to-make-soft-idlis/", 
  },
  {
    name: "Gulab Jamun",
    image: Gulab,
    about: "Gulab jamun is a milk-solid-based sweet and a type of mithai popular in India, Nepal, Bangladesh.",
     source_url: "https://www.indianhealthyrecipes.com/gulab-jamun-recipe-using-milk-powder/",
  },
  {
    name: "Lassi",
    image: Lassi,
    about: "Lassi is a blend of yogurt, water, spices and sometimes fruit.",
     source_url: "https://www.vegrecipesofindia.com/sweet-lassi-punjabi-lassi/",
  },
  {
    name: "Dhokla",
    image: Dhokla,
    about: "A native dish of Gujarat, it is a light and fluffy preparation made by steaming a fermented batter.",
     source_url: "https://www.vegrecipesofindia.com/khaman-dhokla-microwave-recipe/",
  },
  {
    name: "Mushroom-Matar",
    image: Mashroom,
    about: "Mushroom Matar is a delicious Indian curry made using fresh mushrooms and green peas. It pairs well with any Indian bread.",
     source_url: "https://www.vegrecipesofindia.com/matar-mushroom-recipe/",
  },
  {
    name: "Veg-Manchurian",
    image: Manchurian,
    about: "Manchurian is the result of the adaptation of Chinese cooking and seasoning techniques to suit Indian tastes.",
     source_url: "https://www.vegrecipesofindia.com/veg-manchurian-veg-manchurian-gravy/",
  },
];
